import styled from 'styled-components'

export const Header = styled.header`
  width: 100%;
  min-height: 35px;
  padding: 0.5rem 2rem;
  margin-bottom: 2rem;
  background-color: #3fb1f3;
  display: flex;
  align-items: center;
`

export const Body = styled.div`
  padding: 0 1rem;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;

  a {
    align-self: flex-end;
    font-size: 0.8rem;
    margin-bottom: 1rem;
  }
`

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.9rem;

  h2 {
    margin-top: 1.5rem;
    font-size: 1.3rem;
  }
`

export const Paragraph = styled.p`
  font-size: 1rem;
  margin-top: 1rem;
  text-align: center;
  color: #363636;
`

export const Label = styled.label`
  margin: 1.5rem 0 1rem;
  color: #abb4bd;
`

export const ButtonWrapper = styled.div`
  width: 280px;
  margin: 1.5rem 0 1.5rem;
  text-align: center;
`

export const Disclaimer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1rem;
  max-width: 520px;
  color: #919eab;
  font-size: 0.9rem;
`
